import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import { useParams, Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import { Box } from "@mui/material";
import { checkUserPermission } from "../../../common/UserPermission";

const CustomerSummaryReport = (props) => {
  let PERMISSION_EDIT = "/manage-customers/:id";
  const locationid = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  const { CurrencySymbol, FractionDigits } = useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [TierList, setTierList] = useState([]);
  const [salesTypeValue, setSalesTypeValue] = useState();
  const [salesTypeID, setSalesTypeID] = useState(0);
  const [saletype, setSaletype] = useState([]);
  const [tierid, settierid] = useState(0);
  const [totalData, setTotalData] = useState({
    Totalsum: 0,
    Subtotalsum: 0,
    Taxsum: 0,
    Profitsum: 0,
  });
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [selectedlocationid, setSelectedLocationID] = useState(
    Number(locationid)
  );

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const handleChangeTier = (event, index) => {
    console.log(event?.label, event?.value, event?.id, "handleChangeTier");
    settierid(event?.id);
  };

  const handleLocationDropdownChange = (event) => {
    setSelectedLocationID(event?.value);
    console.log(event?.value, "Location chnage");
  };

  let salesTypeDropdownOption = [];
  const SalesTypeDropdown = saletype
    .filter((u) => u.ID !== 3)
    .map((u, i) => {
      salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
    });

  const locationDropdownOption = [
    { label: "All", value: 0 }, // Adding "All" option
    ...locationdropdown.map((u) => ({ label: u.Name, value: u.Id })),
  ];

  let dashStyle = {
    // width: "280px",
    background: "#fff",
    marginTop: "10px",
    borderRadius: "6px",
    padding: "20px",
    border: "1px solid #E8EBED",
  };

  const apiCall = () => {
    setLoading(true);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/customersummaryreport?filtercolumnsearchtext=&currentorder=&ordercolumn=$&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&tierid=${tierid}&saletype=${selectedlocationid}&locationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          if (res.data.ResponseData.length > 0) {
            setResponseData(res.data.ResponseData);
            setTotalData({
              ...totalData,
              Totalsum: res.data.ResponseData[0].Totalsum,
              Subtotalsum: res.data.ResponseData[0].Subtotalsum,
              Taxsum: res.data.ResponseData[0].Taxsum,
              Profitsum: res.data.ResponseData[0].Profitsum,
            });
          } else {
            setTotalData({
              ...totalData,
              Totalsum: 0,
              Subtotalsum: 0,
              Taxsum: 0,
              Profitsum: 0,
            });
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        return;
      });
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/Roletierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        // console.log(response.data?.ResponseData, "response of tire list")
        setTierList(response.data?.ResponseData);
      })
      .catch((error) => {
        console.log(error.message);
      });

    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setSaletype(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setSaletype");
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  const columns = useMemo(() => [
    {
      header: "Person ID",
      accessorKey: "PersonID",
      Cell: checkUserPermission(PERMISSION_EDIT)
        ? ({ row }) => (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight: "700",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                p: "0.3rem",
                cursor: "pointer",
              })}
              onClick={() =>
                window.open(
                  `/manage-customers/${row.original.PersonID}`,
                  "_blank"
                )
              }
            >
              {row.original.PersonID}
            </Box>
          )
        : null,
    },
    {
      header: "Customer",
      accessorKey: "Customer",
      filterFn: "contains",
    },
    {
      header: "PhoneNumber",
      accessorKey: "PhoneNumber",
    },
    {
      header: "Email",
      accessorKey: "EMail",
    },
    {
      header: "Address1",
      accessorKey: "Address1",
      filterFn: "contains",
    },
    {
      header: "Address2",
      accessorKey: "Address2",
      filterFn: "contains",
    },
    {
      header: "City",
      accessorKey: "City",
      filterFn: "contains",
    },
    {
      header: "State/Province",
      accessorKey: "StateProvince",
      filterFn: "contains",
    },
    {
      header: "Zip",
      accessorKey: "Zip",
      filterFn: "contains",
    },
    {
      header: "Subtotal",
      accessorKey: "Subtotal",
      Cell: ({ row }) => {
        const Subtotal = row?.original?.Subtotal;
        if (Subtotal == "0.00" || Subtotal == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(Subtotal),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Total",
      accessorKey: "Total",
      filterFn: "contains",
      enableSorting: false,
      Cell: ({ row }) => {
        const total = row?.original?.Total;
        if (total == "0.00" || total == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(total),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Tax",
      accessorKey: "Tax",
      filterFn: "contains",
      enableSorting: false,
      Cell: ({ row }) => {
        const tax = row?.original?.Tax;
        if (tax == "0.00" || tax == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(Number(tax), { CurrencySymbol }, FractionDigits)}
            </div>
          );
        }
      },
    },
    {
      header: "Profit",
      accessorKey: "Profit",
      filterFn: "contains",
      enableSorting: false,
      Cell: ({ row }) => {
        const profit = row?.original?.Profit;
        if (profit == "0.00" || profit == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(profit),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Number Of Transactions",
      accessorKey: "NumberOfTransactions",
      filterFn: "contains",
      enableSorting: false,
    },
    {
      header: "Average Ticket Size",
      accessorKey: "AverageTicketSize",
      filterFn: "contains",
      enableSorting: false,
      Cell: ({ row }) => {
        const avgTicketSize = row?.original?.AverageTicketSize;
        if (avgTicketSize == "0.00" || avgTicketSize == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(avgTicketSize),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Averge Number of Items Sold Per Transaction",
      accessorKey: "AvergeNumberofItemsSoldPerTransaction",
      filterFn: "contains",
      enableSorting: false,
    },
  ]);

  const handleChangeSalesType = (event) => {
    console.log(event, "handleChangeSalesType");
    setSalesTypeValue(event);
    setSalesTypeID(event?.value);
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  console.log(responseData, "responseData941");
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Customer Summary Report
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-2">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report Period
              </label>
              <div className="row">
                <div className="col-md-12 z-4">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-2 z-4">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Tier Name
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    options={TierList.map((tire) => ({
                      label: tire.Name,
                      value: tire.Code,
                      id: tire.ID,
                    }))}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    onChange={(e, index) => handleChangeTier(e, index)}
                    className="custom-select-search"
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Sale Type
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    defaultValue={salesTypeValue}
                    onChange={(event) => {
                      handleChangeSalesType(event);
                    }}
                    options={salesTypeDropdownOption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Locations
              </label>
              <div className="col-md-12 z-3">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={locationDropdownOption}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  // isClearable={true}
                  name="location"
                  id="location"
                  value={locationDropdownOption.find(
                    (e) => e.value === selectedlocationid
                  )}
                  onChange={(event) => {
                    handleLocationDropdownChange(event);
                  }}
                  className="custom-search-select"
                ></Select>
              </div>
            </div>
            <div className="col">
              {/* align-self-sm-end */}
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                {""}
              </label>

              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apiCall()}
              >
                Run Report
              </button>
            </div>
          </div>

          <div
            className="row"
            style={{
              display: "grid",
              gap: "1rem",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            }}
          >
            <div className="cards">
              <div className="dash-widget" style={dashStyle}>
                <div className="dash-widgetimg"></div>
                <div className="dash-widgetcontent">
                  <p className="p-20">
                    {/* ${totalData.Subtotalsum} */}
                    {CurrencySymbols(
                      Number(totalData.Subtotalsum),
                      { CurrencySymbol },
                      FractionDigits
                    )}
                  </p>
                  <div className="d-flex">
                    <p className="p-medium">Subtotal</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="cards">
              <div className="dash-widget" style={dashStyle}>
                <div className="dash-widgetimg"></div>
                <div className="dash-widgetcontent">
                  <p className="p-20">
                    {/* ${totalData.Totalsum} */}
                    {CurrencySymbols(
                      Number(totalData.Totalsum),
                      { CurrencySymbol },
                      FractionDigits
                    )}
                  </p>
                  <div className="d-flex">
                    <p className="p-medium">Total</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="cards">
              <div className="dash-widget" style={dashStyle}>
                <div className="dash-widgetimg"></div>
                <div className="dash-widgetcontent">
                  <p className="p-20">
                    {/* ${totalData.Taxsum || 0.0} */}
                    {CurrencySymbols(
                      Number(totalData.Taxsum || 0.0),
                      { CurrencySymbol },
                      FractionDigits
                    )}
                  </p>
                  <div className="d-flex">
                    <p className="p-medium">Tax</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="cards">
              <div className="dash-widget" style={dashStyle}>
                <div className="dash-widgetimg"></div>
                <div className="dash-widgetcontent">
                  <p className="p-20">
                    {/* ${totalData.Profitsum} */}
                    {CurrencySymbols(
                      Number(totalData.Profitsum),
                      { CurrencySymbol },
                      FractionDigits
                    )}
                  </p>
                  <div className="d-flex">
                    <p className="p-medium">Profit</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card mt-3">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center " id="header">
                  <h6 class="p">SonarPos</h6>
                  <p className="fw-bold p-regular">Customer Summary Report</p>
                  <div className="row mb-2">
                    <p>
                      Date:{" "}
                      {startdate === "" && enddate === ""
                        ? "All Data"
                        : moment(startdate).format("MM/DD/YYYY") +
                          " - " +
                          moment(enddate).format("MM/DD/YYYY")}
                    </p>
                  </div>
                </div>
              </div>
              <hr />
              <div className="table-responsive">
                <div className="table mt-3"></div>
                <div>
                  <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Customer Summary Report"
                    columns={columns}
                    data={responseData}
                    startdate={startdate}
                    enddate={enddate}
                    columnGrouping={[]}
                    columnsVisibility={{}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerSummaryReport;
